import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';
import {
	Card,
	Row,
	Col,
	FormControl,
	FormGroup,
	FormLabel,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import _ from 'lodash';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';
import Switch from 'react-switch';

import { getMessageFromRequest } from '../../utils/errors';
import Popout from '../../components/Popout';
import Search from '../../components/Search';
import LoadingButton from '../../components/LoadingButton';
import { withUser } from '../../modules/User';
import api from '../../api';
import Grid from '../../components/Grid';
import NumberFormatter from '../../components/Grid/NumberFormatter';
import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import Summary from '../../components/Grid/Summary';
import CurrencySummary from '../../components/Grid/CurrencySummary';

import CurrencySummaryAvg from './CurrencySummaryAvg';
import salesFrequencyColumnsDef from './salesFrequencyColumnsDef';
import './styles.scss';

/*
  <SalesFrequency
    frequenciaVendas={salesFrequency}
    key={freqKey}
    freqKey={freqKey}
    tabAtual={tabAtual}
  />
*/

registerLocale('ptBR', ptBR);

const defaultButtonStyle = {
	width: '100%',
};

const cityToOptions = ({ code, name, stateCode }) => ({
	label: `${code} - ${name} - ${stateCode}`,
	value: code,
});

const customerToOptions = ({ register, name }) => ({
	label: `${register} - ${name}`,
	value: register,
});

const articleToOptions = ({ code, description }) => ({
	label: `${code} - ${description}`,
	value: code,
});

const getValueFromOption = ({ value }) => value;

const getFirstDay = (date) => {
	var newDate = new Date(date);
	var firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
	return firstDay;
};

const getLastDay = (date) => {
	var newDate = new Date(date);
	var lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
	return lastDay;
};

const dateFixed = (date) => new Date(date).toISOString().split('T')[0];

const firstColumn = {
	key: '',
	name: 'Coleções',
	type: 'text',
	resizable: false,
	filterable: false,
	sortable: false,
	frozen: true,
	width: 550,
};

const groupedColumnsWidth = {
	parts: 50,
	references: 50,
	value: 100,
	averagePrice: 70,
};

const INITIAL_STATE = {
	// salesFrequency
	salesFrequency: [],
	freqKey: 0,
	shadowFrequenciaVendas: null,
	gridUpdated: false,

	// artigo de cotas
	articlesOptions: [],
	articlesSelected: [],

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	searchedCidade: [],
	searchedCliente: [],
	// searchedSupervisor: [],
	// suggestionPriority: '',
	route: '',
	bought: false,
	requestDate: getFirstDay(Date.now()),
	requestDateFinal: getLastDay(Date.now()),

	// Page State
	isLoading: false,
	isSending: false,
	currentIndex: 0,
	activeIndex: 0,
};

class SalesFrequency extends Component {
	constructor(props) {
		super(props);
		this.freqVendasRef = React.createRef();
	}

	state = {
		...INITIAL_STATE,
		firstColumn: firstColumn,
		groupedColumnsWidth: groupedColumnsWidth,
		key: 0,

		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	componentDidMount() {
		this.handleGetQuotaArticles();
	}

	// shouldComponentUpdate(nextProps, nextState) {
	//   return this.state.value !== nextState.value;
	// }

	// componentDidMount() {
	//   this.setState({ key: this.state.key + 1 })
	// }

	// Lifecycle
	componentDidUpdate() {
		// Forcar um render a mais na grid para os filtros aparecerem
		if (this.state.gridUpdated === true) {
			this.setState({ gridUpdated: false });
		}

		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
			}
		}
	}

	// Handlers

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */
	handleDateChange = (name, value) => this.setState({ [name]: value });

	handleRequestDate = (requestDate) =>
		this.setState({ requestDate: getFirstDay(requestDate) });

	handleRequestDateFinal = (requestDateFinal) =>
		this.setState({ requestDateFinal: getLastDay(requestDateFinal) });

	handleSearchedCidade = (searchedCidade) => this.setState({ searchedCidade });

	handleSearchedCliente = (searchedCliente) =>
		this.setState({ searchedCliente });

	handleSearchedSupervisor = (searchedSupervisor) =>
		this.setState({ searchedSupervisor });

	handleArticle = (articlesSelected) => this.setState({ articlesSelected });

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			tabAtual: this.state.tabAtual,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	handleSalesFrequency = async () => {
		const {
			requestDate,
			requestDateFinal,
			articlesSelected,
			representante,
			// prioridadeSugestao,
			route,
			bought,
			searchedCidade,
			searchedCliente,
			searchedRepresentante,
		} = this.state;

		const rep = representante === 0 ? searchedRepresentante : representante;

		const params = {
			initialIssueDate: dateFixed(requestDate),
			finalIssueDate: dateFixed(requestDateFinal),
			bought: bought,
			representativeId: rep,
			// prioridadeSugestao: prioridadeSugestao,
			cities: searchedCidade.map(getValueFromOption).toString(),
			customers: searchedCliente.map(getValueFromOption).toString(),
			route: route,
			quotaArticles: articlesSelected.map(getValueFromOption).toString(),
		};
		this.setState({ isLoading: true, salesFrequency: [] });
		try {
			const { data: salesFrequency } =
				await api.comercial.customer.getSaleFrequency({ params: params });

			this.setState({
				salesFrequency,
				freqKey: this.state.freqKey + 1,
				gridUpdated: true,
			});
		} catch (err) {
			toast.error(`Erro ao consultar Frequência de Vendas: ${err.message}`);
		} finally {
			this.setState({ isLoading: false, activeIndex: null });
		}
	};

	// Quota Articles
	handleGetQuotaArticles = async () => {
		this.setState({
			isLoading: true,
			articlesSelected: [],
			articlesOptions: [],
		});
		try {
			const { data } = await api.comercial.filters.quotaArticle.getAll();

			if (data.length === 0) {
				toast.warn('Nenhum artigo encontrado!');
				return;
			}

			const articlesOptions = data.map((article) => articleToOptions(article));
			this.setState({ articlesOptions, articlesSelected: articlesOptions });
		} catch (err) {
			toast.error(`Erro ao consultar Artigos de Cotas: ${err.message}`);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	// Handlers

	handleBoughtSwitch = () => {
		const { bought } = this.state;
		this.setState({ bought: !bought });
	};

	// Largura dos Upper Headers

	getFirstHeaderWidth = (salesFrequencyColumnsDef) => {
		let width = 0;

		salesFrequencyColumnsDef.forEach((column) => {
			width = width + column.width;
		});

		return width;
	};

	getGroupHeaderWidth = (groupColumnsWidth) => {
		let width = 0;

		Object.keys(groupColumnsWidth).forEach((column) => {
			width = width + groupColumnsWidth[column];
		});

		return width;
	};

	// Transforma de frequencia vendas para upper headers

	getUpperHeaderColumns = (
		frequenciaVendas,
		firstColumn,
		groupedColumnsWidth,
	) => {
		let columnsDefNew = []; //
		let keysFromCollections = new Set();

		frequenciaVendas.forEach((customer) => {
			customer.collections.forEach((collection) => {
				Object.keys(collection).forEach((key) => {
					let keyString = key.toString();

					if (keyString === 'collectionDescription') {
						keysFromCollections.add(collection['collectionDescription']);
					}
				});
			});
		});

		// Realiza a criação das novas colunas
		columnsDefNew = Array.from(keysFromCollections).map((key) => {
			return {
				key: key,
				name: key,
				type: 'text',
				resizable: false,
				filterable: false,
				sortable: false,
				frozen: false,
				width: this.getGroupHeaderWidth(groupedColumnsWidth),
			};
		});

		let firstColumnFix = {
			...firstColumn,
			width: this.getFirstHeaderWidth(salesFrequencyColumnsDef),
		};

		// Junta o columnsDef padrão com as novas colunas
		columnsDefNew = [firstColumnFix].concat(columnsDefNew);

		return columnsDefNew;
	};

	// Transforma frequencia vendas nas colunas dinamicas

	getDynamicColumns = (frequenciaVendas, groupedColumnsWidth) => {
		let columnsDefNew = []; //
		let keysFromCollections = new Set();

		frequenciaVendas.forEach((customer) => {
			customer.collections.forEach((collection) => {
				let code = collection.collection;

				Object.keys(collection).forEach((key) => {
					let keyString = key.toString();
					let newKey = keyString + code;

					if (
						keyString === 'averagePrice' ||
						keyString === 'parts' ||
						keyString === 'references' ||
						keyString === 'value'
					) {
						keysFromCollections.add(newKey);
					}
				});
			});
		});

		// Realiza a criação das novas colunas
		columnsDefNew = Array.from(keysFromCollections).map((key) => {
			return this.returnColumnDef(key, groupedColumnsWidth);
		});

		// Junta o columnsDef padrão com as novas colunas
		columnsDefNew = salesFrequencyColumnsDef.concat(columnsDefNew);

		return columnsDefNew;
	};

	// Columns Def Dinamico

	returnColumnDef = (key, groupedColumnsWidth) => {
		let def = {
			key: key,
			name: key,
			type: 'text',
			resizable: false,
			filterable: false,
			sortable: false,
			frozen: false,
			width: 100,
			formatter: '',
			summary: '',
		};

		if (key.includes('parts')) {
			def.name = 'Peças';
			def.width = groupedColumnsWidth.parts;
			def.formatter = NumberFormatter;
			def.summary = Summary;
		} else if (key.includes('references')) {
			def.name = 'Refs';
			def.width = groupedColumnsWidth.references;
			def.formatter = NumberFormatter;
			def.summary = Summary;
		} else if (key.includes('value')) {
			def.name = 'Valor';
			def.width = groupedColumnsWidth.value;
			def.formatter = CurrencyFormatter;
			def.summary = CurrencySummary;
		} else if (key.includes('averagePrice')) {
			def.name = 'PM';
			def.width = groupedColumnsWidth.averagePrice;
			def.formatter = CurrencyFormatter;
			def.summary = CurrencySummaryAvg;
		}
		return def;
	};

	// Transforma o frequencia venda em keys com id (value => value123)

	getFrequenciaVendas = (frequenciaVendas) => {
		let newFrequenciaVendas = frequenciaVendas;

		newFrequenciaVendas.forEach((customer) => {
			customer.collections.forEach((collection) => {
				let code = collection.collection;

				Object.keys(collection).forEach((key) => {
					let keyString = key.toString();
					let newKey = keyString + code;
					customer[newKey] = collection[key];
				});
			});
		});

		return newFrequenciaVendas;
	};

	// Alinha os scrolls das grids

	setScroll = () => {
		let divs = ReactDOM.findDOMNode(
			this.freqVendasRef.current,
		).getElementsByClassName('react-grid-Canvas');
		divs[0].scrollLeft = divs[1].scrollLeft;
	};

	// STANDBY###################

	// Renderiza a row
	rowRenderer = ({ renderBaseRow, ...props }) => {
		if (props.row.isSummary) {
			return <div className="rowSummary">{renderBaseRow(props)}</div>;
		} else {
			return (
				<div>
					<ReactTooltip class="toolTip" />
					{renderBaseRow(props)}
				</div>
			);
		}
	};

	// Insere os totalizadores
	getFrequenciaVendasSummary = (frequenciaVendas) => {
		// transforma frequencia vendas e gera totalizadores
		let newFrequenciaVendas = this.getFrequenciaVendas(frequenciaVendas);
		let totalizadores = this.getTotalizadores(newFrequenciaVendas);

		// array do summary
		let withSummary = [];

		// itera entre o frequencia vendas
		for (let [i, row] of newFrequenciaVendas.entries()) {
			// Checa se n é ultima linha
			if (newFrequenciaVendas[i + 1]) {
				// se for a primeira linha, adiciona o totalizador como primeira
				if (i === 0) {
					withSummary.push(totalizadores[row.suggestionPriority]);
				}

				// adiciona uma row normal
				withSummary.push(row);

				// detectada a troca de suggestionPriority na proxima linha, é adicionado um totalizador
				if (
					row.suggestionPriority !==
					newFrequenciaVendas[i + 1].suggestionPriority
				) {
					withSummary.push(
						totalizadores[newFrequenciaVendas[i + 1].suggestionPriority],
					);
				}
			}
			// na ultima linha só é adicionado uma row
			else {
				withSummary.push(row);
			}
		}

		return withSummary;
	};

	// Gera os totalizadores
	getTotalizadores = (newFrequenciaVendas) => {
		var holder = {};

		newFrequenciaVendas.forEach((customer) => {
			// remove keys desnecessarias
			const {
				city,
				name,
				register,
				collections,
				economicGroup,
				representativeId,
				financialFlag,
				representative,
				route,
				...data
			} = customer;

			// cria a key de suggestionPriority usando o numero
			let prioridadeKey = customer['suggestionPriority'];

			// verifica se ja existe a key no holder, se n tem, adiciona isSummary pro rowRenderer e summary pra não renderizar o semaforo
			if (!holder.hasOwnProperty(prioridadeKey)) {
				holder[prioridadeKey] = { isSummary: true, financialFlag: 'summary' };
			}

			// itera pelas keys
			Object.keys(data).forEach((key) => {
				if (key.includes('collectionDescription') || key.includes('collection'))
					return;

				// verifica se já tem a key
				if (holder[prioridadeKey].hasOwnProperty(key)) {
					// se for a key suggestionPriority somente checa se ja existe  e adiciona
					if (key === 'suggestionPriority') {
						holder[prioridadeKey][key] = data[key] ? data[key] : 0;
					}

					// se for outra key, faz a soma dela
					else {
						holder[prioridadeKey][key] = holder[prioridadeKey][key] + data[key];
					}
					// se n so adiciona
				} else {
					holder[prioridadeKey][key] = data[key] ? data[key] : 0;
				}
			});
		});

		return holder;
	};

	// Calculo de Largura de coluna

	calculateTextWidth = (text) => {
		let freqVendasRef = this.freqVendasRef ? this.freqVendasRef.current : '';
		if (!freqVendasRef) return 0;

		let element = freqVendasRef.getElementsByClassName(
			'react-grid-HeaderCell',
		)[0];
		this.element = document.createElement('canvas');
		this.context = this.element.getContext('2d');
		this.context.font = window
			.getComputedStyle(element)
			.getPropertyValue('font-family');

		return this.context.measureText(text).width;
	};

	getBiggestWidthFromCollectionKey = (frequenciaVendas, key) => {
		var startTime = performance.now();

		let biggestLength = 0;

		frequenciaVendas.forEach((customer) => {
			customer.collections.forEach((collection) => {
				let textLength = this.calculateTextWidth(collection[key]);
				biggestLength = textLength > biggestLength ? textLength : biggestLength;
			});
		});

		var endTime = performance.now();

		console.log(
			`Call to getBiggestWidthFromCollectionKey took ${
				endTime - startTime
			} milliseconds`,
		);

		return biggestLength;
	};

	// Loads

	loadCities = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.city
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(cityToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	loadCustomers = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.customer
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(customerToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	render() {
		const {
			firstColumn,
			groupedColumnsWidth,

			// Quota Articles
			articlesOptions,
			articlesSelected,

			// SalesFrequency
			salesFrequency,
			freqKey,

			// Filters
			representante,
			searchedRepresentante,
			searchedCidade,
			searchedCliente,
			// searchedSupervisor,
			// suggestionPriority,
			route,
			bought,
			requestDate,
			requestDateFinal,

			// Page State
			isLoading,
			// isSending,
			activeIndex,
		} = this.state;

		// Não renderiza se não estiver nessa aba
		// if(tabAtual !== "frequenciaVendas") return <React.Fragment/>

		// Ordem
		// Update de dados gera um novo mount no componente pela nova key

		// getUpperHeaderColumns gera as colunas de cima que vão na primiera grid
		// se baseia nos dados novos do frequencia vendas para pegar o nome de cada coleção
		// o first column para para pegar os columnsDef da primeira coluna de cima, e usa a função getFirstHeaderWidth(salesFrequencyColumnsDef) -+
		// - para gerar a largura dela
		// o groupedColumnsWidth na função getGroupHeaderWidth(groupedColumnsWidth) para gerar a largura de cada uma das colunas de coleção agrupadas
		const upperHeaderColumns = this.getUpperHeaderColumns(
			salesFrequency,
			firstColumn,
			groupedColumnsWidth,
		);

		// getDynamicColumns gera as colunas da grid de baixo
		// utiliza a returnColumnDef(key, groupedColumnsWidth) recebendo a key para gerar a columnDef de cada uma das colunas
		// e groupedColumnsWidth para gerar a largura de cada uma
		const dynamicColumns = this.getDynamicColumns(
			salesFrequency,
			groupedColumnsWidth,
		);

		// getFrequenciaVendas transforma os dados do back em objeto que tenha keys com id especifico para posteriormente gerar columsdef
		const data = this.getFrequenciaVendas(salesFrequency);

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div className="acompVendas-container">
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cidade</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCities}
												onChange={this.handleSearchedCidade}
												value={searchedCidade}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cliente</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCustomers}
												onChange={this.handleSearchedCliente}
												value={searchedCliente}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={1}>
										<FormGroup>
											<FormLabel style={{ marginBottom: '11px' }}>
												Rota
											</FormLabel>
											<FormControl
												className="rounded-input"
												name="route"
												value={route}
												onChange={this.handleFieldChange}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={2}>
										<FormGroup>
											<FormLabel>Coleções</FormLabel>
											<Popout
												name="artigo"
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												isSearchable
												isClearable={true}
												maxDisplay={1}
												menuWidth={'100%'}
												options={articlesOptions}
												onChange={this.handleArticle}
												value={articlesSelected}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={2}>
										<FormGroup>
											<FormLabel>Comprou</FormLabel>
											<div>
												<Switch
													checked={bought}
													onChange={this.handleBoughtSwitch}
													offColor="#dc3545"
													onColor="#28a745"
													width={120}
													uncheckedIcon={
														<div
															style={{ width: '60px', marginLeft: '-40px' }}
															className="switch-center switch-unchecked"
														>
															Sem Compra
														</div>
													}
													checkedIcon={
														<div
															style={{ width: '70px', marginRight: '-40px' }}
															className="switch-center switch-checked"
														>
															Com Compra
														</div>
													}
												/>
											</div>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Emissão</FormLabel>
											<div className="date-filter d-flex justify-content-between">
												<DatePicker
													className="form-control rounded-input"
													selected={requestDate}
													selectsStart
													locale="ptBR"
													startDate={requestDate}
													onChange={this.handleRequestDate}
													dateFormat="MM/yyyy"
													showMonthYearPicker
												/>
												<i className="fa fa-arrow-right fa-md mt-2" />
												<DatePicker
													className="form-control rounded-input"
													selected={requestDateFinal}
													selectsStart
													locale="ptBR"
													startDate={requestDateFinal}
													onChange={this.handleRequestDateFinal}
													dateFormat="MM/yyyy"
													showMonthYearPicker
												/>
											</div>
										</FormGroup>
									</Col>
								}
								{/* {(tabAtual === 'clientes' || tabAtual === 'frequenciaVendas') && (
                  <Col md={1}>
                    <FormGroup>
                      <FormLabel style={{ marginBottom: "11px" }}>PS</FormLabel>
                      <FormControl 
                        className="rounded-input"
                        name="prioridadeSugestao"
                        value={prioridadeSugestao}
                        onChange={this.handleFieldChange}
                      />
                    </FormGroup>
                  </Col>
                )} */}
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={this.handleSalesFrequency}
														isLoading={isLoading}
														// disabled={!representante && searchedCidade.length === 0 && searchedCliente.length === 0 && searchedSupervisor.length === 0}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<Card className="card-indicadores">
					<Card.Body className="align-items-center">
						<div className="salesFrequency-styles" ref={this.freqVendasRef}>
							<Grid
								data={[0]}
								minHeight={20}
								columns={upperHeaderColumns}
								headerRowHeight={20}
							/>
							<Grid
								reflectShadowRows={(shadowFrequenciaVendas) =>
									this.setState({ shadowFrequenciaVendas })
								}
								data={data}
								key={freqKey}
								minHeight={400}
								columns={dynamicColumns}
								rawColumnsDef={dynamicColumns}
								rowHeight={20}
								headerRowHeight={20}
								enableSummary
								highlightActiveRow
								rowRenderer={this.rowRenderer}
								onScroll={this.setScroll}
							/>
						</div>
					</Card.Body>
				</Card>
			</>
		);
	}
}

export default withUser(SalesFrequency);
